import { ActivityLog } from '@wwf/sdk';
import { ListItem, ListItemButton, Stack, Typography } from '@mui/material';
import { ReactNode, Fragment } from 'react';
import { ActivityLogContextValue } from './types';
import { MemberLightCard } from '@app/member/show/MemberLightCard';
import { RelativeDate } from '@app/misc/RelativeDate';
import { ReferenceField } from 'ra-ui-materialui';
import { Link } from 'react-router-dom';

type ActivityLogMemberNoteCreatedProps = {
    activity: ActivityLog;
    context: ActivityLogContextValue;
    header: ReactNode;
    text: string;
    link: string;
};

export function ActivityLogNote({
    activity,
    context,
    header,
    text,
    link,
}: ActivityLogMemberNoteCreatedProps) {
    if (!text) {
        return null;
    }
    const paragraphs = text.split('\n');

    return (
        <ListItem disableGutters>
            <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    width="100%"
                >
                    {header}

                    {activity.authorId && (
                        <>
                            <Typography
                                component="p"
                                variant="body2"
                                color="text.secondary"
                            >
                                by{' '}
                            </Typography>
                            <ReferenceField
                                source="authorId"
                                reference="member"
                                record={activity}
                                link={false}
                            >
                                <MemberLightCard />
                            </ReferenceField>
                        </>
                    )}
                    {context !== 'all' && (
                        <Typography
                            color="textSecondary"
                            variant="body2"
                            component="span"
                            flexGrow={1}
                            sx={{ textAlign: 'end' }}
                        >
                            <RelativeDate date={activity.activityDate} />
                        </Typography>
                    )}
                </Stack>
                <ListItemButton component={Link} to={link}>
                    {context === 'all' && (
                        <Typography
                            color="textSecondary"
                            variant="body2"
                            component="span"
                        >
                            <RelativeDate date={activity.activityDate} />
                        </Typography>
                    )}
                    <Typography
                        variant="body2"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: '3',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {paragraphs.map((paragraph: string, index: number) => (
                            <Fragment key={index}>
                                {paragraph}
                                {index < paragraphs.length - 1 && <br />}
                            </Fragment>
                        ))}
                    </Typography>
                </ListItemButton>
            </Stack>
        </ListItem>
    );
}
